/* eslint-disable eqeqeq */
import { useState, useEffect, useCallback, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Grid from "@mui/material/Grid";
import useMediaQuery from "@mui/material/useMediaQuery"; 
import Modal from "@mui/material/Modal"; 
import SaveRoundedIcon from "@mui/icons-material/SaveRounded"; 
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded"; 
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded"; 
import ViewTimelineOutlinedIcon from "@mui/icons-material/ViewTimelineOutlined";
import Box from "@mui/material/Box"; 

  
import {
  fAlertToast, 
  fcovertToNumber,
} from "../../Utility/Utilitys"; 

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import {
  Set_Truck_HeadObject_Set,
  Set_Truck_HeadObject_Init,
  Set_Truck_HeadObject_New_Set,
  Set_Truck_HeadObject_CBM_Set,
} from "./SliceTruck";
import "./Truck.css";
import {
  CmpButton, 
  CmpButtonKWithIcon,
} from "../../Component/Common/ToolBox/ToolBox";
import { 
  GridDataColumnsWmsSiDetail_Def, 
 
  //headSearch end
  fKeyLoadingReceipt, 
  ErrorMsg,
  fValidationHead_Client, 
  fLoad_Grid,
  fSaveHead, 
  GetAttributes,  
} from "./TruckAction";
// import { set } from 'date-fns/esm';
import { fcheck_null_undefine_replace_empty } from "../../Utility/Utilitys"; 
import { FShortCutKey } from "../../Utility/Utilitys"; 
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import { Truck_Delete_GETROW } from "../../Server/ApiV2";
import GcHead from "./processComponent/GcHead";

export default function Truck() {
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const vRdxWmsHead = useSelector((state) => state.SliceTruck.value.HeadObject);
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
   
  const [sRoundingVal, setRoundingVal] = useState(2);
  
 
  
  //HEAD
  const [sAttribute, setAttribute] = useState({
    Drivers: [], 
  });

  const [sErrorMsg, setErrorMsg] = useState(ErrorMsg);

  //DETAIL
  const [sDetailGridData, setDetailGridData] = useState([]); //DetailGridData Select

  

  //Modal View
  const [sViewModal, setViewModal] = useState(false);
  const fView = () => {
    setViewModal(true);
  };

  const fCloseViewModal = (e) => {
    setViewModal(false);
  };
   //Modal View
  let timeout = null;
  const fSave = async (e) => {
    clearTimeout(timeout);
    fClearErrorMsg();

    timeout = setTimeout(async () => {
      let validation = fValidationHead_Client(vRdxWmsHead, setErrorMsg);
       
      if (!validation) return;    

      fSaveHead(fNew);
    }, 800);
  }; 
  const fNew = async () => {
    fClearErrorMsg();

    dispatch(Set_Truck_HeadObject_Init()); // Head Clearing
    // Setting Initial List Box 0th Object
    dispatch(
      Set_Truck_HeadObject_New_Set({
        DriverName: sAttribute?.Drivers[0]?.UId, 
      })
    );
    fLoad_Grid(setDetailGridData); 
    // document.getElementsByName("B_ItmName")[0]?.focus();
  };
  const fClearErrorMsg = () => {
    setErrorMsg(ErrorMsg);
  };

 
 

  const fDelete = (e) => {
    confirmAlert({
      title: "Delete",
      message: "Are you want to delete line item.",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: () => {
            fDeleteDetail();
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => "",
        },
      ],
    });
  };

  // DELETESIHEAD_GETROW

  //DELETESIDETAIL_GETROW
  const fDeleteDetail = async () => {
    let vDeleteSIDetailObj = {
      v_UId: vRdxWmsHead.TruckCode,
    };

    let FinalObj = fcheck_null_undefine_replace_empty(vDeleteSIDetailObj);
    const vDeleteSIDetail = await Truck_Delete_GETROW(FinalObj);

    if (vDeleteSIDetail?.status == 200) {
      fAlertToast("SUCCESS", "Successfully Deleted Line Item");
      fNew( );
    }
  };

  const fDetail_Grid_onRowClick = async (item) => {
    dispatch(
      Set_Truck_HeadObject_Set({
        ...vRdxWmsHead,
        TruckCode: item.row.UId,
        TrackingID: item.row.Brand,
        DriverName: item.row.Driver,
        TruckName: item.row.Name1,
        PurchaseDate: item.row.PurchaseDt,
        OnService: item.row.Service == 'No' || item.row.Service == 'N' ?'N':'Y',
        OnLease: item.row.Lease == 'No' || item.row.Lease == 'N' ?'N':'Y',
        Sold: item.row.Sold == 'No' || item.row.Sold == 'N' ?'N':'Y',
        WMS: item.row.WMS == 'No' || item.row.WMS == 'N' ?'N':'Y',
        Length: item.row.Length,
        Width: item.row.Width,
        Height: item.row.Height,
        CBM: item.row.CBM,
      })
    );
    fCloseViewModal();
  };
 

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onload = useCallback(async () => {

    if (vRdxDBKernObj.DIGIT_ROUNDING) {
      setRoundingVal(Number(vRdxDBKernObj.DIGIT_ROUNDING?.Val));
    }
    let iAttributeResp = await GetAttributes(setAttribute);

    dispatch(
      Set_Truck_HeadObject_Set({
        ...vRdxWmsHead,
        DriverName:
          vRdxWmsHead.DriverName == "" ||
          vRdxWmsHead?.DriverName == null ||
          vRdxWmsHead?.DriverName == undefined
            ? iAttributeResp?.Drivers[0]?.UId
            : vRdxWmsHead.DriverName,
      })
    );

    fLoad_Grid(setDetailGridData);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  
  // CLICK ANY WHERE AND CLOSE IF TOGGLE IS CLOSED

  const fkeyup = useCallback((e) => {
    if (e.key === "Enter") {
      let lastChild = document?.getElementById("TruckContent");

      let TagArr = !!lastChild
        ? lastChild?.querySelectorAll(".lastkeyDetect")
        : "";
      let ilengthz = !!TagArr ? TagArr?.length : "";

      if (!!ilengthz) {
        if (
          TagArr[ilengthz - 1]?.getElementsByTagName("input")[0]?.name ==
            e.target.name &&
          document?.getElementById("WMSDocStatID")?.innerHTML == "ENTER"
        ) {
          confirmAlert({
            title: "Save",
            message: "Are you want to Save.",
            buttons: [
              {
                className: "alertBtn",
                name: "SaveYes",
                label: "Yes",
                onClick: () => {
                  document.getElementById("IdSave")?.click();
                },
              },
              {
                className: "alertBtn",
                label: "No",
                onClick: () => "",
              },
            ],
          });
        }
      }
    }
  }, []);

  useEffect(() => {
    onload();
  }, [onload]);

  useEffect(() => {
    document.addEventListener("keyup", (e) => fkeyup(e), false);
    return () => {
      document.removeEventListener("keyup", fkeyup, false);
    };
  }, [fkeyup]);

  const fkeyup2 = useCallback(
    (e) => {
      let vRdxPrint = "WMLDLSTH_DET";
      FShortCutKey(
        e,
        "IdNew",
        "IdSave",
        "IdApprove",
        "IdSearch",
        "IdDelete",
        "IdAudit",
        vRdxPrint,
        ()=>{}
      );
    },
    [ ]
  );

  useLayoutEffect(() => {
    window.addEventListener("keyup", fkeyup2);

    return () => {
      window.removeEventListener("keyup", fkeyup2);
    };
  }, [fkeyup2]);

  useEffect(() => {
    let Height =fcovertToNumber(vRdxWmsHead.Height)- fcovertToNumber(vRdxWmsHead.HeightWastage)
    let Width =fcovertToNumber(vRdxWmsHead.Width) - fcovertToNumber(vRdxWmsHead.WidthWastage)
    let Length =fcovertToNumber(vRdxWmsHead.Length) -fcovertToNumber(vRdxWmsHead.LengthWastage) 
    let iCBM =fcovertToNumber(Height) * fcovertToNumber(Width)  * fcovertToNumber(Length) ;
    dispatch(Set_Truck_HeadObject_CBM_Set({
      CBM: iCBM / 1000000,
    }));
  }, [vRdxWmsHead.Length, vRdxWmsHead.Width, vRdxWmsHead.Height]);

  const [GridDataColumnsWmsSiDetail, setGridDataColumnsWmsSiDetail] = useState(
    GridDataColumnsWmsSiDetail_Def
  );
 
 
  return (
    <div className="container-fluid">
      <div
      style={{
        position: "fixed",
        top: 45,
        left: 2,
        width: "100%",
        backgroundColor: "white",
        zIndex: 2,
      }}
    >
         <div>
            {/* mobile Screen nav  */}
            <Grid
              container
              spacing={0}
              className="my-2 Wms-inbound-grn-nav-md-hide"
              columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              sx={{ alignItems: "center" }}
            >
              <Grid
                item
                xs={3}
                sm={1}
                md={1}
                lg={1}
                sx={{ justifyContent: "center", textAlign: "center" }}
              >
                 
                <CmpButtonKWithIcon
                  xOnClick={fNew}
                  xDisabled={
                    false
                  }
                  xIcon={<AddBoxRoundedIcon fontSize={"small"} />}
                />
              </Grid>
              <Grid
                item
                xs={3}
                sm={1}
                md={1}
                lg={1}
                sx={{ justifyContent: "center", textAlign: "center" }}
              >
                 
                <CmpButtonKWithIcon
                  xOnClick={fSave}
                  xDisabled={false}
                  xIcon={<SaveRoundedIcon fontSize={"small"} />}
                  xcolor="success"
                />
              </Grid>

            
           
              <Grid
                item
                xs={3}
                sm={1}
                md={1}
                lg={1}
                sx={{ justifyContent: "center", textAlign: "center" }}
              >
                
                 <CmpButtonKWithIcon
                  xOnClick={() => {
                    fView();
                  }}
                  xDisabled={false}
                  xIcon={<ViewTimelineOutlinedIcon fontSize={"small"} />}
                />
              </Grid>
              <Grid
                item
                xs={3}
                sm={1}
                md={1}
                lg={1}
                sx={{ justifyContent: "center", textAlign: "center" }}
              >
                <CmpButtonKWithIcon
                  xOnClick={fDelete}
                  xDisabled={  false  }
                  xIcon={<DeleteRoundedIcon fontSize={"small"} />}
                  xcolor="error"
                />
              </Grid>
              
            </Grid>
            
         </div>
    </div>
    <div className="row" style={{ padding: "0px" }}>
    <div className="col-12" style={{ padding: "0px" }}>
          <div className="Wms-outbound-grv">
            <Grid
              container
              spacing={0}
              className="my-2 Wms-inbound-grn-nav-sm-hide"
              columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              sx={{ alignItems: "center" }}
            >
              <Grid item xs={1} sm={2} md={1} lg={1}>
                <CmpButton
                  xbtnName="New"
                  xOnClick={(e) => fNew()}
                  xVariant="text"
                  xDisabled={
                    false
                  }
                  xSize="small"
                  xId={"IdNew"}
                  xSendIcon={<AddBoxRoundedIcon />}
                />
              </Grid>
              <Grid item xs={1} sm={2.5} md={1} lg={1}>
                <CmpButton
                  xbtnName="Save"
                  xOnClick={fSave}
                  xVariant="text"
                  xDisabled={false}
                  xSize="small"
                  xId={"IdSave"}
                  xSendIcon={<SaveRoundedIcon />}
                />
              </Grid>
            
              <Grid item xs={1} sm={2.5} md={1} lg={1}>
                <CmpButton
                  xbtnName="Delete"
                  xOnClick={fDelete}
                  xVariant="text"
                  xDisabled={
                     
                    false
                  }
                  xSize="small"
                  xId="IdDelete"
                  xSendIcon={<DeleteRoundedIcon />}
                />
              </Grid>
             
               
               
            </Grid>
          
          
            <>
              <div id="wms-salese-invoice-id">
                <div className=" wms-incoice-sales-m main-wms-sales-invoice-hide-sm main-wms-sales-invoice-show-sm ">
                  <GcHead
                    xErrorMsg={sErrorMsg}
                    xKey={fKeyLoadingReceipt}
                    vRdxWmsHead={vRdxWmsHead}
                    sAttribute={sAttribute}
                  />
                </div>
                <div className="wms-sales-Content wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                  <div className="wms-sales-content-grid xs-screen-hide">
                    <div style={{ height: "60vh", width: "100%" }}>
                      <DataGrid
                        rowHeight={30}
                        headerHeight={40}
                        getRowClassName={(params) =>
                          params.indexRelativeToCurrentPage % 2 === 0
                            ? "mui-even-row"
                            : "mui-odd-row"
                        }
                        sx={{
                          border: 1,
                          borderColor: "primary.light",
                        }}
                        rows={sDetailGridData}
                        columns={GridDataColumnsWmsSiDetail}
                        onRowClick={fDetail_Grid_onRowClick}
                        hideFooter={sDetailGridData.length < 100}
                        components={{
                          Toolbar: vMediaQuery ? '':GridToolbar,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          </div>
        </div>
      </div>

      {/* //View Modal  */}
      <Modal
        open={sViewModal}
        onClose={fCloseViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"View"} onClose={fCloseViewModal} />
          <div className="py-2">
            <div style={{ height: "70vh", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                rows={sDetailGridData}
                columns={GridDataColumnsWmsSiDetail}
                onRowClick={fDetail_Grid_onRowClick}
                hideFooter={sDetailGridData.length < 100}
                components={{
                  Toolbar: vMediaQuery ? '':GridToolbar,
                }}
              />
            </div>
          </div>
        </Box>
      </Modal>

   

     
    </div>
  );
}
